import BillDateWithTimezone from '@/common/components/BillDateWithTimezone'
import Button from '@/common/components/Button'
import ImageWithDisplayName from '@/common/components/ImageWithDisplayName'
import { formatCurrency, formatDate } from '@/common/utils/formatters'
import { billingSupplyAuthorizationStatus } from '@/features/supplyAuthorizations/constants/billingSupplyAuthorizationStatus.constant'
import { BillingSupplyAuthorizationListData } from '@/features/supplyAuthorizations/types/billingSupplyAuthorization.type'
import { ArrowBigRightDashIcon, BriefcaseBusinessIcon, User2Icon } from 'lucide-react'
import { Link } from 'react-router-dom'

export class BillingSupplyAuthorizationTransformer {
  static tableTransformer() {
    return (supplyAuthorizations: BillingSupplyAuthorizationListData[]) => {
      return supplyAuthorizations.map((supplyAuthorization) => {
        return {
          ...supplyAuthorization,
          status: billingSupplyAuthorizationStatus[supplyAuthorization.status],
          number: supplyAuthorization.bill?.number || '',
          client: supplyAuthorization.bill?.client_branch?.company?.general_information ? (
            <ImageWithDisplayName
              placeholderIcon={BriefcaseBusinessIcon}
              imageUrl={
                supplyAuthorization.bill?.client_branch?.general_information
                  ? supplyAuthorization.bill?.client_branch?.general_information?.company_logo?.url
                  : supplyAuthorization.bill?.client_branch?.company?.general_information?.company_logo?.url
              }
              displayName={
                supplyAuthorization.bill?.client_branch?.company?.general_information
                  ? supplyAuthorization.bill?.client_branch?.company?.general_information?.fantasy_name
                  : supplyAuthorization.bill?.client_branch?.company?.general_information?.fantasy_name
              }
            />
          ) : (
            ''
          ),
          amount: formatCurrency(Number(supplyAuthorization.amount)),
          total_amount: formatCurrency(Number(supplyAuthorization.bill?.total_amount)),
          opened_at: supplyAuthorization.bill?.opened_at && (
            <BillDateWithTimezone
              date={supplyAuthorization.bill?.opened_at}
              timezone={supplyAuthorization.bill?.time_zone || undefined}
            />
          ),
          closed_at: supplyAuthorization.bill?.closed_at && (
            <BillDateWithTimezone
              date={supplyAuthorization.bill?.closed_at}
              timezone={supplyAuthorization.bill?.time_zone || undefined}
            />
          ),
          author: supplyAuthorization.creator ? (
            <ImageWithDisplayName
              placeholderIcon={User2Icon}
              imageUrl={supplyAuthorization.creator?.profile_picture?.url}
              displayName={supplyAuthorization.creator?.full_name}
            />
          ) : (
            ''
          ),
          created_at: formatDate(new Date(supplyAuthorization.created_at || 0)),
          actions: (
            <Link to={`/supply-authorizations/${supplyAuthorization.id}`}>
              <Button
                className="bg-transparent hover:bg-transparent disabled:hover:bg-transparent p-0"
                operationKlassToCheckPermission="Client::Billing::SupplyAuthorizations::Show"
              >
                <ArrowBigRightDashIcon strokeWidth={1} />
              </Button>
            </Link>
          ),
        }
      })
    }
  }
}
